import { formatPrice } from '@/shared/lib/utils/price/format-price'

import cl from './style.module.scss'

type TradeInContentProps = {
	price: number
}

export const TradeInContent = ({ price }: TradeInContentProps) => {
	const RESULT = price > 0 ? `до ${formatPrice(price)}` : 'Выгода до 100 %'
	return (
		<div className={cl.content}>
			<h3 className={cl.title}>Ваша выгода при покупке по обмену в Трейд-ин:</h3>
			<p className={cl.subtitle}>{RESULT}</p>
			<p className={cl.notation}>*Для уточнения максимального размера выгоды заполните все поля</p>
		</div>
	)
}
